
export function parseRequestBody(reqBody) {
    const parsedBody = {...reqBody};

    for(const key in parsedBody){
        if(Object.prototype.hasOwnProperty.call(parsedBody, key)){
            const value = parsedBody[key];
            const regexCheck = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;
            if(regexCheck.test(value) && value !== null) parsedBody[key] = parseFloat(value);
            if(value == null) delete parsedBody[key];
        }
    }
    return parsedBody;
}

export function parseReqBodyNumber(req){
    const parsedBody = {...req};
    for(const key in parsedBody){
        const convertedVal = Number(parsedBody[key])
        if(!isNaN(convertedVal) && parsedBody[key] !== '' && parsedBody[key] !== null) parsedBody[key] = convertedVal
        if(parsedBody[key] == null) delete parsedBody[key];
    }
    return parsedBody;
}